import { IQuickLink } from 'shared/common/state';

import { QuickLinksTitle } from '../QuickLinksTitle';

import { QuickLinkItem } from './components/QuickLinkItem';

import * as styles from './QuickLinksList.css';

export interface IQuickLinksListProps {
  linkGroups: IQuickLink[][];
  level: number;
}

export function QuickLinksList(props: IQuickLinksListProps) {
  const { linkGroups, level } = props;

  return (
    <div className={styles['section']}>
      <QuickLinksTitle>Рекомендуем посмотреть</QuickLinksTitle>
      <div className={styles['list']}>
        {linkGroups.map((links, index) => {
          return (
            <div className={styles['column']} key={`quicks_link_${index}`}>
              {links.map((link, i) => {
                return (
                  <QuickLinkItem
                    key={`quick_link_${i}`}
                    level={level}
                    offersCount={link.offersCount}
                    title={link.title}
                    url={link.url}
                  />
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}
